import { useEffect, useState } from "react";
import about1 from "../assets/images/about-1.jpg";
import about2 from "../assets/images/about-2.jpg";
import about3 from "../assets/images/about-3.jpg";

const About = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(
                "https://2btpaefd.api.sanity.io/v2025-04-10/data/query/production?query=*%5B_type+%3D%3D+%22page%22%5D+%7B%0A++title%2C+text%0A%7D&perspective=drafts"
            );
            const json = await response.json();
            setData(json.result);
        };

        fetchData();
    }, []);

    return (
        <section id="om-oss" className="py-16 px-6 md:px-20 bg-white">
            <p className="text-green-600 font-normal mb-2">Bærekraft i praksis</p>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">{data?.[3]?.title || ""}</h2>
            <p className="text-gray-700 max-w-3xl mb-12">{data?.[3]?.text || ""}</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {[about1, about2, about3].map((img, i) => (
                    <div key={i} className="overflow-hidden rounded-lg shadow-md">
                        <img src={img} alt={`About ${i + 1}`} className="w-full h-full object-cover" />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default About;
